<template>
  <div class="tpehealth-app-layer-table-page col-block width-full">
    <div class="tpehealth-app-layer-table-main-container col-block width-full" :style="tableOption.style === 'striped' ? { border: '0px' } : {}">
      <layerTableItem
        :option="tableOption"
      ></layerTableItem>
      <layerTableItem
        :datas="tableDatas"
        :option="tableOption"
      ></layerTableItem>
    </div>
  </div>
</template>

<script>
import layerTableItem from './layerTableItem.vue'

export default {
  components: {
    layerTableItem
  },
  props: {
    datas: {
      type: Array,
      required: true
    },
    option: {
      type: Object,
      required: true
    }
  },
  computed: {
    tableDatas () {
      let generateTableData = (datas, option, lengthDatas = []) => {
        let subOption = option.options.find(option => option.options)
        let subLengthDatas = lengthDatas.slice(1)
        return {
          'data': datas.map((data, index) => {
            let subResult = subOption ? generateTableData(data[subOption.key], subOption, subLengthDatas) : null
            subResult && (subLengthDatas = subResult['length'].map((l, i) => l + (subLengthDatas[i] || 0)))
            return {
              ...data,
              ...(subOption ? { [subOption.key]: subResult['data'] } : {}),
              number: (lengthDatas[0] || 0) + index + 1
            }
          }),
          'length': [datas.length, ...subLengthDatas]
        }
      }
      let result = generateTableData(this.datas, this.tableOption)
      return result['data']
    },
    tableOption () {
      return this.option
    }
  }
}
</script>
